import { FC, memo } from 'react'

import { getRequest } from 'pages/api/axios'
import { currImageDomain, STATIC_URL } from 'constants/data'

const imgPath = {
  preview: `${STATIC_URL}/cards/preview.png`,
}

interface IPreviewImage extends React.ImgHTMLAttributes<HTMLImageElement> {
  url?: string
  isCheckNeed: boolean
}

const PreviewImage: FC<IPreviewImage> = ({ url, isCheckNeed, ...props }: IPreviewImage) => {
  const handleLoadError = (e: any) => {
    const target = e.target
    target.onerror = null
    target.onload = null
    target.src = imgPath.preview
    target.style.objectPosition = '16% 0%'
  }

  const handleLoad = (e: any) => {
    try {
      e.target.onload = null
      if (url && isCheckNeed) getRequest(url)
    } catch (err) {
      console.log(err)
      handleLoadError(e)
    }
  }

  return (
    <img
      onError={handleLoadError}
      onLoad={handleLoad}
      {...props}
      src={props.src ? currImageDomain + props.src : imgPath.preview}
      alt="Превью содержания"
      decoding="async"
      // loading="lazy"
    />
  )
}

export default memo(PreviewImage)
